// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type { PostInformationEntityListBody, BaseResponseListInformationEntity } from '../../types';

/**
 * queryList
 *
 * @export
 * @tags information-entity-controller
 * @link [POST] /information-entity/list
 */
export function postInformationEntityList(
    data: PostInformationEntityListBody
): Promise<BaseResponseListInformationEntity>;
export function postInformationEntityList(
    data: PostInformationEntityListBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseListInformationEntity>;
export function postInformationEntityList(
    data: PostInformationEntityListBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseListInformationEntity> {
    return request<PostInformationEntityListBody, never, never>('/information-entity/list', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postInformationEntityList',
    });
}

export const meta = [
    { tags: ['information-entity-controller'], path: '/information-entity/list', method: 'post' },
];
